import React, { createContext, useContext, useState, useEffect } from 'react';

const PlayerContext = createContext();

export const usePlayer = () => {
  const context = useContext(PlayerContext);
  if (!context) {
    throw new Error('usePlayer must be used within a PlayerProvider');
  }
  return context;
};

export const PlayerProvider = ({ children }) => {
  const [player, setPlayer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Check for stored session on mount
    const storedPlayer = localStorage.getItem('playerSession');
    if (storedPlayer) {
      try {
        setPlayer(JSON.parse(storedPlayer));
      } catch (e) {
        localStorage.removeItem('playerSession');
      }
    }
    setLoading(false);
  }, []);

  const login = (playerData) => {
    setPlayer(playerData);
    localStorage.setItem('playerSession', JSON.stringify(playerData));
  };

  const logout = () => {
    setPlayer(null);
    localStorage.removeItem('playerSession');
  };

  const updatePlayer = (updates) => {
    const updated = { ...player, ...updates };
    setPlayer(updated);
    localStorage.setItem('playerSession', JSON.stringify(updated));
  };

  return (
    <PlayerContext.Provider value={{ player, login, logout, updatePlayer, loading }}>
      {children}
    </PlayerContext.Provider>
  );
};
